import { render, staticRenderFns } from "./AdminAlterClientOrder.vue?vue&type=template&id=32b9b21e&"
import script from "./AdminAlterClientOrder.vue?vue&type=script&lang=js&"
export * from "./AdminAlterClientOrder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports